import api from "../../../../../api";


export function requestGetMaintenanceConfig() {
    return api.get('/admin/maintenance-config');
}

export function requestGetSettingsConfig() {
    return api.get('/admin/settings-config');
}
